// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateUser_root__oSrB1 {
    margin: 20px 20px;
}

.CreateUser_breadcrumb__BachW {
    margin-bottom: 20px;
}

.CreateUser_label__mZVit {
    font-size: 14px !important;
    font-weight: 600 !important;
}

.CreateUser_formItem__OsowN {
    margin-bottom: 10px;
}

.CreateUser_submitButton__L\\+QaL,
.CreateUser_backButton__QbDPJ {
    margin-top: 15px;
    width: 100%;
    font-size: 16px;
    min-height: auto;
}

.CreateUser_buttonsHolder__2tWvx {
    & .ant-form-item {
        margin-bottom: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/CreateUser/CreateUser.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".root {\n    margin: 20px 20px;\n}\n\n.breadcrumb {\n    margin-bottom: 20px;\n}\n\n.label {\n    font-size: 14px !important;\n    font-weight: 600 !important;\n}\n\n.formItem {\n    margin-bottom: 10px;\n}\n\n.submitButton,\n.backButton {\n    margin-top: 15px;\n    width: 100%;\n    font-size: 16px;\n    min-height: auto;\n}\n\n.buttonsHolder {\n    & :global(.ant-form-item) {\n        margin-bottom: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CreateUser_root__oSrB1`,
	"breadcrumb": `CreateUser_breadcrumb__BachW`,
	"label": `CreateUser_label__mZVit`,
	"formItem": `CreateUser_formItem__OsowN`,
	"submitButton": `CreateUser_submitButton__L+QaL`,
	"backButton": `CreateUser_backButton__QbDPJ`,
	"buttonsHolder": `CreateUser_buttonsHolder__2tWvx`
};
export default ___CSS_LOADER_EXPORT___;
